import { Fragment, useEffect } from 'react'

import { useCurrentUserId } from 'lib/use-current-user-id'
import toSafeInteger from 'lodash/toSafeInteger'
import { useRouter } from 'next/router'

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

const Hotjar = ({ children }: Props) => {
  const userId = useCurrentUserId()
  const router = useRouter()

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const handleRouteChange = () => {}

    try {
      import('react-hotjar').then(({ hotjar }) => {
        hotjar.initialize(
          toSafeInteger(process.env.NEXT_PUBLIC_HOTJAR_ID ?? 0),
          toSafeInteger(process.env.NEXT_PUBLIC_HOTJAR_VERSION ?? 6)
        )

        const handleRouteChange = (page) => {
          if (page instanceof Location) {
            page = page.href
          }

          hotjar.stateChange(page.replace(/^https?:\/\/[^/]+\//i, '/'))
        }

        router.events.on('routeChangeComplete', handleRouteChange)
      })
    } catch (error) {
      // it's a side effect
      // nothing should go wrong for the user
    }

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [userId, router.events])

  return <Fragment>{children}</Fragment>
}

export default Hotjar
